import { logger } from '@vagabondinternet/logging';
import { useEffect, useState } from 'react';
import type { PresenceSource } from './presence-source';

/** The players count from `source`: undefined while loading, null when unavailable or on error. */
export const usePlayersCount = (source: PresenceSource): number | null | undefined => {
  const [count, setCount] = useState<number | null>();

  useEffect(() => {
    let current = true;
    source
      .getPlayersCount()
      .then((next) => {
        if (current) setCount(next);
      })
      .catch((error: unknown) => {
        logger.error({ message: 'Failed to load the players count', error });
        if (current) setCount(null);
      });
    return () => {
      current = false;
    };
  }, [source]);

  return count;
};
